import { formatNumber } from '../../packages/utils/numberFormatters'

const rightsText = { singular: 'rätt', plural: 'rätter' }
const sharesText = { singular: 'aktie', plural: 'aktier' }
const unitsText = { singular: 'unit', plural: 'units' }
const warrantsText = { singular: 'teckningsoption', plural: 'teckningsoptioner' }

const label = (text, quantity, locale) => {
    return `${formatNumber(quantity, { locale, decimals: 0 })} ${quantity === 1 ? text.singular : text.plural}`
}

const quantityLabel = (issue, quantity, locale) => {
    const text = isUnit(issue) ? unitsText : sharesText
    return label(text, quantity, locale)
}

const rightsQuantityLabel = (quantity, locale) => label(rightsText, quantity, locale)
const sharesQuantityLabel = (quantity, locale) => label(sharesText, quantity, locale)
const unitsQuantityLabel = (quantity, locale) => label(unitsText, quantity, locale)
const warrantsQuantityLabel = (quantity, locale) => label(warrantsText, quantity, locale)

function isUnit(issue) {
    if (issue.type === 'Rights issue' || issue.type === 'IPO') {
        // maybe unit
        return issue.hasWarrant || issue.warrants?.length > 0 || issue.sharesInUnit !== 1 || issue.unitExtraContent
    } else {
        // always share
        return false
    }
}

const isShare = (issue) => !isUnit(issue)

export {
    isShare,
    isUnit,
    quantityLabel,
    rightsQuantityLabel,
    sharesQuantityLabel,
    unitsQuantityLabel,
    warrantsQuantityLabel,
}
